// A field that saves as it's left (DataControl's onBlur) is left on Enter too: one save, never two with the
// same version (Books setup's chart names). DataTable puts it on the field's cell.

/** The key that reached the cell, and where it was pressed. */
interface KeyAt {
  key: string;
  target: EventTarget | null;
}

/** On Enter in a text box, leaves it (its onBlur saves); any other key, or a select, does nothing. */
export function leaveOnEnter(e: KeyAt): void {
  const box = e.target as { tagName?: string; blur?: () => void } | null;
  if (e.key === 'Enter' && box?.tagName === 'INPUT') box.blur?.();
}
